import { helpers } from '@vuelidate/validators'

// We use the same regex Postmark uses to validate email addresses
// For mor information, see https://postmarkapp.com/support/article/1180-what-does-errorcode-300-mean
export const postmarkEmail = helpers.regex(/^[a-zA-Z0-9.!#$%&'`*+\-/=^_{}|~]+@((\.)?[a-zA-Z0-9-])+\.[a-zA-Z]{2,}$/)

